/* ==========================================================================
   BOTAVERRA - LIGNE DE REASSURANCE DU HERO

   POURQUOI CE FICHIER EXISTE. Le contenu du hero vit dans
   `templates/index.json`, un fichier de 60 Ko : l'API de thème exige d'envoyer
   le fichier entier a chaque ecriture, ce qui n'est pas tenable pour trois
   lignes de texte. La voie normale etait donc d'ajouter un bloc "Liquid
   personnalise" dans l'editeur ; l'utilisateur ne l'a pas trouve, et le
   2026-09-01 a demande que ce soit fait autrement. Meme bequille que
   botaverra-hero-lien.js, pour la meme raison.

   LE TEXTE N'EST PAS ICI. Il vient de `window.BV_HERO_RASSURE`, serialise dans
   snippets/stylesheets.liquid - lui-meme alimente par le menu
   "hero-reassurance" s'il existe dans Boutique en ligne > Navigation. Modifier
   les trois arguments ne demande donc jamais de toucher a ce script.

   IL SE DESACTIVE TOUT SEUL. Si un jour un bloc Liquid personnalise est ajoute
   dans l'editeur avec la meme classe `.bvhero-rassure`, ce script voit que la
   liste existe deja et ne fait rien. Rien a supprimer ce jour-la : le balisage
   de l'editeur, lui, est visible des moteurs de recherche, donc il vaut mieux
   que ce script - c'est la limite connue de l'approche.

   LE PLACEMENT ET L'HABILLAGE sont dans assets/botaverra-corrections.css
   (`.bvhero-rassure`). Ce script ne fait que poser le balisage attendu :
   un div enveloppe, une liste dedans - la regle CSS `:has()` compte dessus.
   ========================================================================== */

(function () {
  function poser() {
    var liste = window.BV_HERO_RASSURE;

    if (!Array.isArray(liste) || liste.length === 0) return;
    if (document.querySelector('.bvhero-rassure')) return;

    var hote =
      document.querySelector('.hero .hero__content-wrapper') ||
      document.querySelector('.hero__content-wrapper');

    if (!hote) return;

    var enveloppe = document.createElement('div');
    var ul = document.createElement('ul');
    ul.className = 'bvhero-rassure';

    liste.forEach(function (texte) {
      if (!texte) return;
      var li = document.createElement('li');
      li.textContent = texte;
      ul.appendChild(li);
    });

    if (!ul.children.length) return;

    enveloppe.appendChild(ul);
    hote.appendChild(enveloppe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poser);
  } else {
    poser();
  }
})();
